
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-03ea2d31\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../../vue-loader/lib/selector?type=styles&index=0!./overlay.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./overlay.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-03ea2d31\"}!../../../../vue-loader/lib/selector?type=template&index=0!./overlay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/internal/popup/overlay.vue
// module id = 368
// module chunks = 1